import React, { useState, useEffect } from 'react';
import classes from './SectionTitle.module.scss';

const SectionTitle = ({ className, style, children }) => {
  const [ratioX, setRatioX] = useState(0);

  useEffect(()=> {
    const mouseMoveHandler = (e)=> {
      const ratX = (e.pageX - window.innerWidth/2) / (window.innerWidth/2);
      setRatioX(ratX);
    }
    window.addEventListener('mousemove', mouseMoveHandler);
    return ()=> window.removeEventListener('mousemove', mouseMoveHandler);
  }, []);

  const rootClass = [classes.SectionTitle];
  if (className) rootClass.push(className);

  return (
    <h1 className={rootClass.join(' ')} style={style ? style:{}}>
      <span className={[classes.Span, classes.Blue].join(' ')} style={{
        transform: `translate(${-4 * ratioX}px, -3px)`
      }}>{children}</span>
      <span className={[classes.Span, classes.Red].join(' ')} style={{
        transform: `translate(${4 * ratioX}px, 3px)`
      }}>{children}</span>
      {children}
    </h1>
  );
}

export default SectionTitle;